module.exports = __webpack_public_path__ + "static/media/larm-min.6bdf3f7f.png";